'use client'

// src/context/useAuth.ts
import { useContext, useEffect } from "react";

// src/context/context.tsx
import { createContext } from "react";
var authContext = createContext(null);
var context_default = authContext;

// src/context/useAuth.ts
var useAuth = ({ autoFetch } = {}) => {
  const context = useContext(context_default);
  if (!context) {
    throw new Error(
      "useAuth must be used within an AuthProvider, refer to usage instructions: https://github.com/nadude/webook-frontend/blob/main/packages/auth/README.md"
    );
  }
  useEffect(() => {
    if (autoFetch && !context.autoInit && !context.user) {
      context.fetchUser();
    }
  }, [autoFetch]);
  return context;
};

export {
  context_default,
  useAuth
};
//# sourceMappingURL=chunk-ZF2ENNTR.mjs.map